import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function EditUser(row) {
  const navigate = useNavigate();
  const [role, setRole] = useState("");

  const handleChange = (event) => {
    setRole(event.target.value);
  };
  return (
    <Stack direction='column' spacing={2}>
      <TextField fullWidth label='Name' id='name'>
        {row.user}
      </TextField>
      <TextField fullWidth label='Email' id='email'>
        {row.status}
      </TextField>

      <Stack direction='row' spacing={2}>
        <Button variant='contained' disabled>
          SAVE
        </Button>
        <Button variant='contained' color='error'>
          CANCEL
        </Button>
      </Stack>
    </Stack>
  );
}
